export const RANKS = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'] as const;
export const SUITS = ['S', 'H', 'D', 'C'] as const;

export const PHASES = {
  SETUP: 'setup',
  PLAYING: 'playing',
  BETWEEN_ROUNDS: 'betweenRounds',
  SCORING: 'scoring',
  GAME_OVER: 'gameOver',
} as const;

export const MODES = {
  TWO_PLAYER: '2p',
  FOUR_PLAYER: '4p',
} as const;

export const ACTIONS = {
  NEW_GAME: 'NEW_GAME',
  DEAL_INITIAL: 'DEAL_INITIAL',
  START_ROUND: 'START_ROUND',
  PLACE_PENDING_ROYALS: 'PLACE_PENDING_ROYALS',
  DROP: 'DROP',
  TAKE_SINGLE: 'TAKE_SINGLE',
  TAKE_SINGLE_ADD_TO_BUILD: 'TAKE_SINGLE_ADD_TO_BUILD',
  TAKE_SINGLE_ADD_TO_STAY: 'TAKE_SINGLE_ADD_TO_STAY',
  TAKE_SUBSET: 'TAKE_SUBSET',
  TAKE_SUBSET_ADD_TO_BUILD: 'TAKE_SUBSET_ADD_TO_BUILD',
  TAKE_SUBSET_ADD_TO_STAY: 'TAKE_SUBSET_ADD_TO_STAY',
  TAKE_PILE: 'TAKE_PILE',
  TAKE_PILE_ADD_TO_BUILD: 'TAKE_PILE_ADD_TO_BUILD',
  TAKE_PILE_ADD_TO_STAY: 'TAKE_PILE_ADD_TO_STAY',
  TAKE_ROYAL_FROM_COLLECTION: 'TAKE_ROYAL_FROM_COLLECTION',
  REMOVE_ROYAL_COVER: 'REMOVE_ROYAL_COVER',
  STEAL_COLLECTION_TOP: 'STEAL_COLLECTION_TOP',
  BUILD_CREATE: 'BUILD_CREATE',
  BUILD_UPDATE: 'BUILD_UPDATE',
  ADD_TO_BUILD: 'ADD_TO_BUILD',
  ADD_TO_STAY: 'ADD_TO_STAY',
  REINFORCE_BUILD: 'REINFORCE_BUILD',
  REINFORCE_STAY: 'REINFORCE_STAY',
  STAY_CREATE: 'STAY_CREATE',
  STAY_FROM_OPP_COLLECTION: 'STAY_FROM_OPP_COLLECTION',
  INCREASE_OPP_TOP_TO_MATCH: 'INCREASE_OPP_TOP_TO_MATCH',
  BUILD_SOLID_FROM_TABLE: 'BUILD_SOLID_FROM_TABLE',
  BUILD_SOLID_FROM_OPP_TOP: 'BUILD_SOLID_FROM_OPP_TOP',
  ABSORB_CHOOSE: 'ABSORB_CHOOSE',
  ABSORB_SKIP: 'ABSORB_SKIP',
} as const;
